import { render, staticRenderFns } from "./xcy.vue?vue&type=template&id=00cf0ed4&scoped=true"
import script from "./xcy.vue?vue&type=script&lang=js"
export * from "./xcy.vue?vue&type=script&lang=js"
import style0 from "./xcy.vue?vue&type=style&index=0&id=00cf0ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf0ed4",
  null
  
)

export default component.exports